export const tr = {
    translation: {
        b: {
            cancel: 'İptal',
            confirm: 'Onayla',
            send: 'Gönder',
            done: 'Bitti',
            close: 'Kapat',
            clear: 'Temizle',
            copy_link: 'Bağlantıyı kopyala',
            export: 'Dışa aktar',
            delete: 'Sil',
            delete_confirm: 'Silmeyi onayla',
            duplicate: 'Çoğalt',
            share: 'Paylaş',
            sign_in: 'Giriş yap',
            sign_up: 'Kayıt ol',
            email_address: 'E-posta adresi',
            yes: 'Evet',
            no: 'Hayır'
        },
        m_languages: {
            title: 'Diller',
            subtitle: 'Bir dil seçin'
        },
        m_feedback: {
            feature: {
                name: 'Özellik isteği',
                desc: 'İhtiyacınız olan bir özellik eksik mi? Bize bildirin — fikirleriniz değerli'
            },
            feedback: {
                name: 'Geri bildirim',
                desc: 'Geri bildiriminiz bizim için çok değerli — kısa bir not bırakın'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Öneriniz için teşekkürler!',
                desc: 'Düşüncelerinizi paylaşmak için zaman ayırmanıza gerçekten minnettarız — bu, iyileştirmemize yardımcı olur.'
            },
            feedback: {
                name: 'Geri bildiriminiz için teşekkürler!',
                desc: 'Düşüncelerinizi paylaşmak için zaman ayırmanıza gerçekten minnettarız — bu, iyileştirmemize yardımcı olur.'
            }
        },
        m_diagram_details: {
            name_place: 'Proje adını girin',
            desc_place: 'Proje açıklamasını girin'
        },
        m_quick_share: {
            title: 'Hızlı paylaşım',
            subtitle: '(Bağlantı ile)'
        },
        m_export_img: {
            title: 'Görseli dışa aktar'
        },
        m_export_code: {
            title: '{{db_engine}} kodunu dışa aktar',
            download_file: 'Dosyayı indir',
            copy_code: 'Kodu kopyala'
        },
        m_sign_in_remind: {
            title: 'DB Design’ı denediğiniz için teşekkürler',
            subtitle: 'Tablo sayısı sınırını artırmak, diyagramları kaydetmek ve daha fazla özelliğin kilidini açmak için giriş yapın veya kayıt olun.'
        },
        m_sign_in_restrict: {
            title: 'Uygulamada daha fazlasını yapmak için giriş yapın',
            subtitle: 'Tablo sınırlarını artırmak, diyagramları kaydetmek ve daha fazla özelliğin kilidini açmak için giriş yapın veya kayıt olun.'
        },
        m_new_diagram: {
            title: 'Yeni diyagram',
            subtitle: 'Bir veritabanı motoru seçin',
            open_diagram: 'Diyagramı aç'
        },
        m_keyboard_shortcuts: {
            title: 'Klavye kısayolları',
            ctrl_left: {
                title1: 'Kontroller',
                title2: '(Sol)',
                items: {
                    mouse_sel: 'Fare seçimi / El modu',
                    table: 'Tablo',
                    line: 'Çizgi',
                    area: 'Alan',
                    note: 'Not',
                    comment: 'Yorum',
                    pen: 'Kalem',
                    undo: 'Geri al',
                    redo: 'Yeniden yap'
                }
            },
            ctrl_top_left: {
                title1: 'Kontroller',
                title2: '(Sol üst)',
                items: {
                    export_img: 'Görseli dışa aktar',
                    search: 'Ara',
                    editor_panel: 'Düzenleyici paneli'
                }
            },
            ctrl_bottom_right: {
                title1: 'Kontroller',
                title2: '(Sağ alt)',
                items: {
                    minimap: 'Mini harita',
                    zoom_in: 'Yakınlaştır',
                    zoom_out: 'Uzaklaştır',
                    zoom_100: 'Zoom %100'
                }
            },
            ctx_tab: {
                title1: 'Bağlam menüsü',
                title2: '(Tablo)',
                items: {
                    dupl_tab: 'Tabloyu çoğalt',
                    del_tab: 'Tabloyu sil'
                }
            },
            ctx_del_tab: {
                title1: 'Bağlam menüsü',
                title2: '(Tabloyu sil)',
                items: {
                    yes: 'Evet',
                    no: 'Hayır'
                }
            },
            ctx_tab_col: {
                title1: 'Bağlam menüsü',
                title2: '(Sütunu)', // Tablo sütunu
                items: {
                    add_col_below: 'Alta sütun ekle',
                    focus_col_above: 'Odağı üstteki sütununa taşı',
                    focus_col_below: 'Odağı alttaki sütununa taşı',
                    move_col_up: 'Sütunu yukarı taşı',
                    move_col_down: 'Sütunu aşağı taşı',
                    dupl_col: 'Sütunu çoğalt',
                    del_col: 'Sütunu sil'
                }
            },
            ctx_line: {
                title1: 'Bağlam menüsü',
                title2: '(Çizgi)',
                items: {
                    del_line: 'Çizgiyi sil'
                }
            },
            ctx_area: {
                title1: 'Bağlam menüsü',
                title2: '(Alan)',
                items: {
                    dupl_area: 'Alanı çoğalt',
                    del_area: 'Alanı sil'
                }
            },
            ctx_multi: {
                title1: 'Bağlam menüsü',
                title2: '(Çoklu seçim)',
                items: {
                    select_all: 'Tüm öğeleri seç',
                    create_area_for_select_els: 'Seçili öğeler için alan oluştur',
                    dupl_select_els: 'Seçili öğeleri çoğalt',
                    del_select_els: 'Seçili öğeleri sil'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Fare seçimi',
                table: 'Tablo',
                line: 'Çizgi',
                area: 'Alan',
                note: 'Not (yakında)',
                comment: 'Yorum (yakında)',
                pen: 'Kalem',
                undo: 'Geri al',
                redo: 'Yeniden yap'
            },
            ctrl_top_left: {
                logo: 'Not: Burası bir sandbox (deneme alanı)',
                name: 'Diyagram bilgileri',
                editor: 'Düzenleyici (yakında)',
                search: 'Arama (yakında)',
                export: 'Dışa aktarma seçenekleri',
                view_mode: 'Görünüm modu',
                zoom_to_fit: 'Ekrana sığdır'
            },
            ctrl_top_right: {
                feature_req: 'Özellik isteği',
                sign_in: 'Giriş yap',
                quick_share: 'Hızlı paylaşım'
            },
            ctrl_bottom_right: {
                full_screen: 'Tam ekran',
                minimap: 'Mini harita',
                zoom_out: 'Uzaklaştır',
                zoom_100: 'Zoom %100',
                zoom_in: 'Yakınlaştır',
                info: 'Bilgi ve kaynaklar'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Varsayılan',
                        blue: 'Mavi',
                        green: 'Yeşil',
                        red: 'Kırmızı',
                        purple: 'Mor',
                        violet: 'Menekşe'
                    },
                    borders: {
                        none: 'Yok',
                        solid: 'Düz',
                        dashed: 'Kesik çizgi',
                        dotted: 'Noktalı'
                    },
                    color: 'Renk',
                    border: 'Kenarlık',
                    description: 'Açıklama',
                    description_table_place: 'Tablo açıklaması',
                    description_column_place: 'Sütun açıklaması',
                    description_line_place: 'Çizgi açıklaması',
                    description_note_place: 'Not açıklaması',
                    description_area_place: 'Alan açıklaması',
                    description_pen_place: 'Kalem açıklaması',
                    hide_menu: 'Menüyü gizle',
                    show_menu: 'Menüyü göster'
                },
                tab_col: {
                    add_col_below: 'Alta sütun ekle',
                    add_col_above: 'Üste sütun ekle',
                    key: 'Key',
                    keys: {
                        none: 'Yok',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Yok',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Sütunu aşağı taşı',
                    move_col_up: 'Sütunu yukarı taşı',
                    more_functions: 'Diğer işlevler'
                },
                line: {
                    change_connects: 'Bağlayıcıları değiştir',
                    connects: {
                        empty: 'Boş',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Öğeleri filtrele'
                },
                multi: {
                    filter: 'Seçimi filtrele',
                    create_area: 'Alan oluştur'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Tam',
            keys_only: 'Yalnızca anahtarlar',
            names_only: 'Yalnızca adlar'
        },
        dropdown_ctrl_export: {
            export_img: 'Görseli dışa aktar',
            export_code: 'SQL kodunu dışa aktar'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Giriş yap',
            new_project: 'Yeni proje',
            keyboard_shortcuts: 'Klavye kısayolları',
            languages: 'Diller'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Geri bildirim',
            keyboard_shortcuts: 'Klavye kısayolları',
            languages: 'Diller',
            homepage: 'Ana sayfa'
        },
        n: {
            default: 'Yükleniyor…',
            file_ready_to_download: 'Dosya indirmeye hazır',
            code_copied: 'Kod kopyalandı',
            link_copied: 'Bağlantı kopyalandı',
            please_enter_message: 'Lütfen bir mesaj girin',
            invalid_email: 'E-posta geçerli değil',
            something_wrong_contact: 'Bir şeyler yanlış gitti. Lütfen sayfayı yeniden yüklemeyi deneyin veya bizimle iletişime geçin.',
            something_wrong: 'Bir şeyler yanlış gitti. Lütfen sayfayı yeniden yüklemeyi deneyin.',
            sending: 'Gönderiliyor…',
            request_sent: 'İstek gönderildi. Teşekkürler!'
        }
    }
};

export const trMeta = {
    lang_origin: 'Türkçe',
    lang_eng: 'Turkish',
    lang_code: 'tr',
};
